// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SplatRouteImport } from './routes/$'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AirbnbRouteImport } from './routes/airbnb'
import { Route as CleaningServicesEncinoRouteImport } from './routes/cleaning-services-encino'
import { Route as CleaningServicesStudioCityRouteImport } from './routes/cleaning-services-studio-city'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as HouseCleaningShermanOaksRouteImport } from './routes/house-cleaning-sherman-oaks'
import { Route as HouseCleaningVanNuysRouteImport } from './routes/house-cleaning-van-nuys'
import { Route as QuoteRouteImport } from './routes/quote'
import { Route as ServicesRouteImport } from './routes/services'
import { Route as ArticlesIndexRouteImport } from './routes/articles/index'
import { Route as ArticlesSlugRouteImport } from './routes/articles/$slug'
import { Route as ServiceAreasIndexRouteImport } from './routes/service-areas/index'
import { Route as ServiceAreasCityRouteImport } from './routes/service-areas/$city'
import { Route as ServicesServiceRouteImport } from './routes/services_.$service'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AirbnbRoute = AirbnbRouteImport.update({
            id: '/airbnb',path: '/airbnb',getParentRoute: () => rootRouteImport
          })
const CleaningServicesEncinoRoute = CleaningServicesEncinoRouteImport.update({
            id: '/cleaning-services-encino',path: '/cleaning-services-encino',getParentRoute: () => rootRouteImport
          })
const CleaningServicesStudioCityRoute = CleaningServicesStudioCityRouteImport.update({
            id: '/cleaning-services-studio-city',path: '/cleaning-services-studio-city',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const HouseCleaningShermanOaksRoute = HouseCleaningShermanOaksRouteImport.update({
            id: '/house-cleaning-sherman-oaks',path: '/house-cleaning-sherman-oaks',getParentRoute: () => rootRouteImport
          })
const HouseCleaningVanNuysRoute = HouseCleaningVanNuysRouteImport.update({
            id: '/house-cleaning-van-nuys',path: '/house-cleaning-van-nuys',getParentRoute: () => rootRouteImport
          })
const QuoteRoute = QuoteRouteImport.update({
            id: '/quote',path: '/quote',getParentRoute: () => rootRouteImport
          })
const ServicesRoute = ServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => rootRouteImport
          })
const ArticlesIndexRoute = ArticlesIndexRouteImport.update({
            id: '/articles/',path: '/articles/',getParentRoute: () => rootRouteImport
          })
const ArticlesSlugRoute = ArticlesSlugRouteImport.update({
            id: '/articles/$slug',path: '/articles/$slug',getParentRoute: () => rootRouteImport
          })
const ServiceAreasIndexRoute = ServiceAreasIndexRouteImport.update({
            id: '/service-areas/',path: '/service-areas/',getParentRoute: () => rootRouteImport
          })
const ServiceAreasCityRoute = ServiceAreasCityRouteImport.update({
            id: '/service-areas/$city',path: '/service-areas/$city',getParentRoute: () => rootRouteImport
          })
const ServicesServiceRoute = ServicesServiceRouteImport.update({
            id: '/services_/$service',path: '/services/$service',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,SplatRoute: SplatRoute,AboutRoute: AboutRoute,AirbnbRoute: AirbnbRoute,CleaningServicesEncinoRoute: CleaningServicesEncinoRoute,CleaningServicesStudioCityRoute: CleaningServicesStudioCityRoute,ContactRoute: ContactRoute,HouseCleaningShermanOaksRoute: HouseCleaningShermanOaksRoute,HouseCleaningVanNuysRoute: HouseCleaningVanNuysRoute,QuoteRoute: QuoteRoute,ServicesRoute: ServicesRoute,ArticlesSlugRoute: ArticlesSlugRoute,ServiceAreasCityRoute: ServiceAreasCityRoute,ServicesServiceRoute: ServicesServiceRoute,ArticlesIndexRoute: ArticlesIndexRoute,ServiceAreasIndexRoute: ServiceAreasIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)